import React from 'react'

export const Button = (props) => {
  const {
    buttonText = '',
    url = '',
    isButtonLink = false,
    isDisabled = false,
    onClick = () => { },
    buttonType = 'button',
    isButtonInline = false,
    icon,
    hasButtonIcon = false,
  } = props

  const className = isButtonInline ? 'button button__inline' : 'button'

  const iconElement = (icon || hasButtonIcon) && icon ? (
    <i className={`${icon} icon__spacing`} aria-hidden="true" />
  ) : null

  if (isButtonLink) {
    if (isDisabled) {
      return (
        <span
          className={className}
          aria-disabled="true"
          role="link"
        >
          {iconElement}
          {buttonText}
        </span>
      )
    }

    return (
      <a
        href={url}
        rel="noopener noreferrer"
        target="_blank"
        className={className}
        onClick={onClick}
      >
        {iconElement}
        {buttonText}
        <span className="visually-hidden"> (opens in new tab)</span>
      </a>
    )
  }

  return (
    <button
      disabled={isDisabled}
      onClick={onClick}
      className={className}
      type={buttonType}
    >
      {iconElement}
      {buttonText}
    </button>
  )
}

export default Button
